import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { TypeOcrH6 } from './Types';

export default function ConservationBannerPangolin() {
  return (
    <>
      <Box sx={{ backgroundColor: 'success.main', width: '100%', my: 2 }}>
        <Stack
          direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
          justifyContent={{ xs: 'center', sm: 'center', md: 'space-evenly' }}
          alignItems={{ xs: 'center', md: 'space-evenly' }}
        >
          <Box sx={{ m: 3, ml: 8, fit: 'scale-down' }}>
            <StaticImage
              src='./pangolin.png'
              height={300}
              alt='a stylized pangolin drawing'
            />
          </Box>
          <Stack alignItems='center' justifyContent='center'>
            <TypeOcrH6 mx={2}>Save Pangolins</TypeOcrH6>
            <Typography align='center' mx={2} mb={2}>
              Noise Engineering is happy to be a founding business partner of{' '}
              {''}
              <a
                href='https://www.savepangolins.org/'
                target='_blank'
                rel='noopener noreferrer'
              >
                Savepangolins.org
              </a>
              . A portion of the proceeds of every Manis Iteritas sold will be
              contributed to pangolin conservation. Buy a Manis, feel good about
              yourself!
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </>
  );
}
